import React from 'react';
import './About.css';

const About = () => {
  return (
    <section className="about" id="about">
      <div className="about-content">
        <h2>Hakkımızda</h2>
        <p>
          Dijikopi, Mersin merkezli olarak <strong>Canon</strong> başta olmak üzere tüm marka fotokopi makineleri, yazıcılar, faks cihazları ve ofis ekipmanları için teknik servis, tamir, bakım, kiralama, <strong>satış</strong> ve toner hizmetleri sunan uzman bir firmadır.
        </p>
        <p>
          Özellikle Canon cihazlarında uzmanlaşmış teknik ekibimiz, renkli ve siyah-beyaz yazıcılar, fotokopi makineleri, faks cihazları ve çok fonksiyonlu ofis makineleri için hızlı ve güvenilir çözümler üretmektedir. 
          <strong>Mürekkepli ve lazer cihazlar</strong>, <strong>orijinal ve muadil toner</strong>, <strong>kartuş dolumu</strong> ve <strong>mobil teknik servis</strong> hizmetleriyle müşterilerimize yerinde hizmet sağlıyoruz.
        </p>
        <p>
          Kurumsal ve bireysel müşterilerimiz için sunduğumuz başlıca hizmetler şunlardır:
        </p>
        <ul>
          <li>Fotokopi, yazıcı, faks cihazı tamiri ve periyodik bakımı</li>
          <li>Canon marka cihazlar için öncelikli servis ve parça desteği</li>
          <li>Renkli ve renksiz fotokopi makineleri kiralama hizmeti</li>
          <li>Fotokopi makineleri ve yazıcı satışı (sıfır veya ikinci el)</li>
          <li>Toner, kartuş ve mürekkep dolumu (orijinal/muadil)</li>
          <li>Yerinde teknik servis – cihazın bulunduğu adrese teknik destek</li>
        </ul>
        <p>
          Dijikopi olarak müşterilerimizin zamanına ve iş sürekliliğine önem veriyor, bakım ve servis işlemlerini hızlı, ekonomik ve profesyonel şekilde gerçekleştiriyoruz. Ofisinizin tüm baskı ihtiyaçlarında çözüm ortağınız olarak yanınızdayız.
        </p>
      </div>
    </section>
  );
};

export default About;